import React from 'react'
import './index.styl'

const NotFound = () => {
    return <div className="not-found-page">404</div>
}

export default NotFound
